import store from '@/store/store';
import {setContext} from 'apollo-link-context';
import {i18n} from '@/store/i18n';

export const authLink = (setContext(async (_, {headers}) => {
  headers = {...headers};

  const val = Object.fromEntries(document.cookie.split('; ')
    .reverse().map((v) => v.split('=').map(decodeURIComponent)));
  const csrf = val['XSRF-TOKEN'];

  if (csrf !== null) {
    headers['X-XSRF-Token'] = csrf;
  }
  headers.Origin = location.origin;
  headers['Accept-Language'] = i18n.locale;
  headers.accept = 'application/json';

  return {
    headers,
    fetchOptions: {
      headers,
    },
  };
}));
